// Modules
import { useEffect, useState } from "react";
import { useRouter } from "next/router";

// Types
import { StripeInfo, ViewType } from "interfaces/shared/userInfo";

// Utils
import {getQueryStringGroupedValue, getUrlWithoutQueryParams} from "utils/searchPage/queryString";

// Redux
import {categoriesSelector} from "redux/searchPage/categories/categoriesSlice";
import { useAppSelector } from "redux/hooks";

interface StripeProps {
    stripeActive: StripeInfo[];
    isMobileStripe: boolean;
}

const findMatchingItem = (items: StripeInfo[], currentPath: string): StripeInfo | null => {
    return items.find(item => getUrlWithoutQueryParams(item.viewvalue) === getUrlWithoutQueryParams(currentPath)) || null;
};

const findSearchTypeItem = (items: StripeInfo[]): StripeInfo | null => {
    return items.find(item => item.viewtype === ViewType.Search) || null;
};

const Stripe = ({ stripeActive, isMobileStripe }: StripeProps) => {
    const [activeItem, setActiveItem] = useState<StripeInfo | null>(null);
    const categories = useAppSelector(categoriesSelector);
    const router = useRouter();
    const { asPath } = router;

    useEffect(() => {
        if (!asPath.startsWith(`/${process.env.NEXT_PUBLIC_SEARCH_PATH_NAME}`)) {
            setActiveItem(stripeActive[0]);
            return;
        }
        const categoriesUrlParameter = categories.map((category) => category.urlParameter);
        const queryStringGroupedValue = getQueryStringGroupedValue(asPath).map(filter => filter.parameter);
        const categoryIsPresentInQueryString = categoriesUrlParameter.some((urlParameter) => queryStringGroupedValue.includes(urlParameter));

        let newActiveItem = null;
        if (!categoryIsPresentInQueryString) {
            const path = getUrlWithoutQueryParams(asPath);
            newActiveItem = findMatchingItem(stripeActive, path);
        }
        if (!newActiveItem) {
            newActiveItem = findSearchTypeItem(stripeActive);
        }

        setActiveItem(newActiveItem);
    }, [asPath, stripeActive]);

    if (activeItem) {
        return (
            <div
                className={`wk-top-promo-banner ${isMobileStripe ? 'wk-mobile-banner' : ''}`}
                style={{ backgroundColor: activeItem.stripecolor }}
                dangerouslySetInnerHTML={{ __html: activeItem.text }}>
            </div>
        );
    }
    return null;
}

export default Stripe;
